export const rutValidator = (rut: string) => {
	// Eliminar los puntos del RUT
	rut = rut.replace(/\./g, '');

	// Verificar el formato básico con la expresión regular
	const isValidFormat = /^(\d{7,8})-(\d|k|K)$/.test(rut);
	if (!isValidFormat) return false;

	const [rutNumber, verifier] = rut.split('-');

	// Convertir el RUT en un arreglo de dígitos en orden inverso
	const reverseRutArray = rutNumber.split('').reverse().map(Number);

	// Calcular el dígito verificador
	let multiplier = 2;
	const total = reverseRutArray.reduce((acc, digit) => {
		acc += digit * multiplier;
		multiplier = multiplier === 7 ? 2 : multiplier + 1;
		return acc;
	}, 0);

	// Obtener el dígito verificador correcto
	const calculatedVerifier = 11 - (total % 11);
	const finalVerifier = calculatedVerifier === 11 ? '0' : calculatedVerifier === 10 ? 'K' : calculatedVerifier.toString();

	// Comparar el dígito verificador calculado con el entregado
	return finalVerifier.toLowerCase() === verifier.toLowerCase();
};

// Función para formatear el RUT
export const formatRut = (rut: string) => {
	// Remueve cualquier carácter que no sea dígito o guión
	const cleanRut = rut.replace(/[^\dkK]/g, '');

	// Aplica el formato de RUT (XX.XXX.XXX-X)
	const rutBody = cleanRut.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	const dv = cleanRut.slice(-1).toUpperCase();

	return `${rutBody}-${dv}`;
};
